<template>
  <section class="!rounded-xl heightClass">
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
    >
      <div class="flex items-center !gap-3">
        <el-button
          @click="goBack()"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>
        <span class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !w-64 truncate">
          Discussion Forums
        </span>
      </div>
    </div>
    <div class="!p-3">
      <div v-if="showForbidden">
        <el-empty description="You have not configured any discussion forums"></el-empty>
      </div>
      <div v-else>
        <div v-loading="loading" class="grid grid-cols-1 md:!grid-cols-[2fr_1fr]">
          <el-card
            class="px-0 lg:!pr-4 2xl:!pr-6 !py-0 lg:!pl-4 [&>div]:!p-0 !box-border h-[calc(100vh-170px)] overflow-y-auto !bg-transparent !border-page-border"
          >
            <el-tag
              id="tagWithClose"
              class="!bg-brand-50 !border-brand-500 !text-brand-500 !px-2 !py-1 !rounded-md text-xxs 2xl:!text-xs !font-normal cursor-pointer !mb-2 !h-auto !leading-normal"
              style="color: var(--brand-500); background-color: var(--brand-50)"
              v-if="hilightedTag"
              closable
              @close="removeTag"
            >
              {{ hilightedTag }}
            </el-tag>

            <div v-if="allForums.length">
              <el-row
                v-for="(forum, index) in allForums"
                :key="forum._id"
                class="!border-b !border-page-border rounded-none !p-3 hover:bg-brand-100 hover:bg-opacity-10 transition-all duration-300 ease-in-out"
              >
                <el-col :span="24">
                  <div @click="openForum(forum._id)" class="cursor-pointer">
                    <div class="d-flex justify-content-between align-items-center !mb-2">
                      <div
                        class="text-black-950 font-normal text-xs xl:text-sm 2xl:!text-base hover:text-brand-500 transition-all duration-300 ease-in-out"
                      >
                        {{ forum.title }}
                      </div>

                      <el-tag
                        v-if="isNewForum(forum)"
                        type="success"
                        class="ml-2 animated-new-tag !bg-brand-500 !border-brand-500 !rounded-full !text-white"
                        size="small"
                        effect="dark"
                      >
                        New
                      </el-tag>
                      <el-tag
                        v-else-if="getUnreadCount(forum)"
                        class="animated-new-tag !rounded-full !bg-brand-500 !border-brand-500"
                        type="danger"
                        size="small"
                        effect="dark"
                      >
                        {{ getUnreadCount(forum) }}
                      </el-tag>
                    </div>
                    <div class="truncate-2-lines">
                      <span
                        class="text-black-700 font-normal text-xxs xl:!text-xs 2xl:!text-[13px]"
                      >
                        {{ extractTextFromHTML(forum.content) }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="!mt-1 flex flex-col xl:!flex-row justify-start !gap-3 xl:!gap-6 items-start xl:!items-center !py-0.5 !rounded-lg"
                  >
                    <div class="flex gap-2 items-center">
                      <div class="icon-block initial">
                        <div v-if="entityUserInfoData[forum.created_by]?.avatar">
                          <img
                            :src="entityUserInfoData[forum.created_by].avatar"
                            alt="IMG"
                            width="30"
                            height="30"
                            style="border-radius: 50%"
                            class="!border !border-page-border"
                          />
                        </div>
                        <div class="icon" v-else>
                          <div class="initial-text">
                            <span>{{ getInitials(forum) }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="text-black-950 font-normal text-xs xl:text-smd 2xl:!text-sm">
                        {{ getCreatedBy(forum) }}
                      </span>
                      <span class="text-black-500 text-xxs 2xl:!text-xs font-normal">
                        {{ forum.created_at | getFormattedDateTypeThree }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center" style="gap: 16px">
                      <div class="d-flex align-items-center" style="gap: 6px; cursor: pointer">
                        <img
                          v-if="forum.liked_by.includes(getAuthenticatedUser._id)"
                          class="!size-4"
                          src="../../../public/assets/img/icons/Like-Fill.svg"
                          @click="dislike(index)"
                        />
                        <img
                          v-else
                          class="!size-4"
                          src="../../../public/assets/img/icons/Like-Outline.svg"
                          @click="like(index)"
                        />
                        <span class="text-black-700 text-xs font-normal">
                          {{ forum.liked_by.length }}
                          <span class="hidden lg:!inline-flex">Likes</span>
                        </span>
                      </div>
                      <div class="w-[1px] h-4 bg-black-200"></div>
                      <div class="d-flex align-items-center" style="gap: 6px">
                        <img
                          src="@/assets/img/icons/new/forums/comment-icon.svg"
                          alt=""
                          class="!size-4"
                        />
                        <span class="text-black-700 text-xs font-normal">
                          {{ forum.comments.length }}
                          <span class="hidden lg:!inline-flex">Comments</span>
                        </span>
                      </div>
                      <div class="w-[1px] h-4 bg-black-200"></div>

                      <div class="d-flex align-items-center" style="gap: 6px">
                        <img
                          src="@/assets/img/icons/new/forums/view-icon.svg"
                          alt=""
                          class="!size-4"
                        />
                        <span class="text-black-700 text-xs font-normal">
                          {{ forum.read_by.length }}
                          <span class="hidden lg:!inline-flex">Views</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center !mt-2 gap-y-2 flex-wrap">
                    <span
                      class="!bg-transparent !border-none !text-brand-500 !px-2 !rounded-md text-xxs xl:text-xs 2xl:!text-[13px] !font-normal cursor-pointer"
                      style="color: var(--brand-500); background-color: transparent"
                      v-for="tag in forum.tags"
                      :key="tag"
                      @click="openTag(tag)"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-if="hasMore"
                style="align-items: center; justify-content: center; display: flex"
              >
                <span class="tag-name cursor-pointer" @click="loadMore">
                  {{ showMoreLoading ? 'Fetching...' : 'Show more activity' }}
                </span>
              </el-row>
            </div>
            <div v-else>
              <el-empty></el-empty>
            </div>
          </el-card>
          <div
            class="lg:!border-l lg:!border-page-border p-0 lg:!pl-6 2xl:!pl-8 !box-border h-[calc(100vh-170px)] overflow-y-auto"
          >
            <el-row justify="center" class="ask-button-row">
              <el-button
                style="background: var(--brand-500) !important"
                class="!py-2 w-full text-center text-xs !font-normal text-white !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto"
                type="primary"
                @click="askNewQuestion"
              >
                Ask your question
              </el-button>
            </el-row>
            <div class="tag-box">
              <div class="tag-header"># Tags</div>
              <div class="tag-list max-h-56 overflow-y-auto">
                <div v-for="tag in tags" :key="tag._id" class="tag-row">
                  <div
                    class="tag-name tag-title !px-2 !py-0.5 !rounded-lg cursor-pointer"
                    @click="openTag(tag._id)"
                  >
                    {{ tag._id }}
                  </div>
                  <el-tag size="small" class="!bg-[#3333331A] text-black-950 !rounded-full">
                    {{ tag.count }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="gradient-border !p-[1px] mt-2 rounded-2xl">
              <div class="tag-box !border-none !bg-white rounded-2xl">
                <div class="tag-header flex items-center !gap-1.5 !border-none !pb-0">
                  <img src="@/assets/img/icons/new/forums/graph-icon.svg" alt="" class="!size-4" />
                  <span>Most Discussed Topics</span>
                </div>
                <div class="tag-list max-h-44 overflow-y-auto">
                  <div v-for="topic in topics" :key="topic._id" class="tag-row !mb-1.5">
                    <div
                      class="text-xs 2xl:text-sm text-black-700 hover:text-blue-600"
                      style="cursor: pointer"
                      @click="openForum(topic._id)"
                    >
                      {{ topic.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { postAPICall } from '../../helpers/httpHelper';
  export default {
    data() {
      return {
        allForums: [],
        entityUserInfoData: {},
        tags: [],
        topics: [],
        page: 1,
        limit: 10,
        url: '',
        hasMore: false,
        loading: false,
        forumsLoading: false,
        hilightedTag: '',
        showMoreLoading: false,
        payload: null,
        showForbidden: false,
      };
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveContactType']),
      ...mapGetters('menuManagementV2', ['getEntityMenu']),
      ...mapGetters('applicationUsersPermission', ['getEntityPermission']),
      isApplicationUser() {
        return this.$route.name == 'ApplicationUserAllForums' ? true : false;
      },
    },
    async mounted() {
      await this.getNecessaryInfo();
    },
    methods: {
      async getNecessaryInfo() {
        this.loading = true;
        this.showForbidden = false;
        let entities_list = [];
        let menu;
        let entityId = this.$route?.query?.entity_id?.includes('@')
          ? this.$route.query.entity_id.split('@')[0]
          : this.$route.query.entity_id;
        let params = {};
        if (this.isApplicationUser) {
          let id = this.$route.query.menu_id;
          if (id) {
            this.getEntityMenu.menu_list.forEach((e) => {
              if (e._id == id) {
                menu = e;
              } else if (e.children) {
                (e.children || []).forEach((el) => {
                  if (el._id == id) {
                    menu = el;
                  } else if (el.children) {
                    (el.children || []).forEach((ele) => {
                      if (ele._id == id) {
                        menu = ele;
                      }
                    });
                  }
                });
              }
            });
            if (menu.forum_entities) {
              entities_list = menu.forum_entities;
            }
          } else if (entityId && this.$route.query.entity_data_id) {
            if (
              this.getEntityPermission?.relational_entities &&
              Object.keys(this.getEntityPermission.relational_entities).includes(entityId)
            ) {
              let response = await postAPICall('POST', '/entities-data/entity/data/v2', {
                entity_id: entityId,
                entity_data_ids: [this.$route.query.entity_data_id],
                template_fields_data: [],
                filters: [
                  {
                    field: 'self#related_to/1',
                    operator: '=',
                    value: this.getActiveContactType.account_data_id,
                    value_type: '',
                    value_source: '',
                    query_type: 'AND',
                    value_field: '',
                    validations: {
                      data_type: '',
                    },
                    nested_related_id: '',
                    data_source: 'self_field',
                    relation_entity_id: this.getActiveContactType.contact_type._id,
                    data_type: 'RELATION',
                  },
                ],
              });
              if (!response.data.data.length) {
                this.showForbidden = true;
                return;
              }
            } else if (
              !this.getEntityPermission.other_entities ||
              !Object.keys(this.getEntityPermission.other_entities).includes(entityId)
            ) {
              this.showForbidden = true;
              return;
            }
          } else {
            this.showForbidden = true;
            return;
          }
        }
        if (entities_list.length) {
          this.payload = entities_list.map((e) => {
            if (e.includes('@') && e.split('@')[1] == 'RELATIONSHIP') {
              return {
                entity_id: e.split('@')[0],
                filters: [
                  {
                    field: 'self#related_to/1',
                    operator: '=',
                    value: this.getActiveContactType.account_data_id,
                    value_type: '',
                    value_source: '',
                    query_type: 'AND',
                    value_field: '',
                    validations: {
                      data_type: '',
                    },
                    nested_related_id: '',
                    data_source: 'self_field',
                    relation_entity_id: this.getActiveContactType.contact_type._id,
                    data_type: 'RELATION',
                  },
                ],
              };
            } else {
              return {
                entity_id: e,
                filters: [],
              };
            }
          });
        }
        params.data = this.payload;
        let entityDataId = this.$route.query.entity_data_id;
        if (this.$route.query.tag) {
          this.hilightedTag = decodeURIComponent(this.$route.query.tag);
        }
        if (entityDataId && entityId) {
          this.url = `/forums/get-threads-by-entity-data/${entityId}/${entityDataId}`;
        } else if (entityId) {
          this.url = '/forums/get-threads-by-entity/' + entityId;
        } else {
          this.url = '/forums/get-all-threads';
        }
        let query = `?page=${this.page}&limit=${this.limit}`;
        if (this.hilightedTag) {
          query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
        }
        let [response, tags, topics] = await Promise.all([
          postAPICall('POST', this.url + query, params),
          postAPICall('POST', '/forums/most-used-tags', params),
          postAPICall('POST', '/forums/most-discussed-threads', params),
        ]);
        this.tags = tags.data;
        this.topics = topics.data;
        if (response.data.length) {
          this.hasMore = response.hasMore;
          this.allForums = [...this.allForums, ...response.data];
          await this.fetchUsersInfo(response.data);
        }
        this.loading = false;
      },
      askNewQuestion() {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.tag;
        let path = this.isApplicationUser ? '/ap/create-forum' : '/create-forum';
        this.$router.push({ path, query });
      },
      openForum(id) {
        let path = this.isApplicationUser ? `/ap/forum/${id}` : `/forum/${id}`;
        let query = this.isApplicationUser
          ? {
              menu_id: this.$route.query.menu_id,
            }
          : {};
        this.$router.push({
          path,
          query,
        });
      },
      async fetchUsersInfo(data) {
        let usersInfo = data.map((forum) => forum.created_by);
        let usersResponse = await postAPICall('POST', '/entities-data/users-info', {
          contact_ids: usersInfo,
          user_ids: usersInfo,
        });
        this.entityUserInfoData = {
          ...this.entityUserInfoData,
          ...usersResponse.data,
        };
      },
      async loadMore() {
        this.showMoreLoading = true;
        this.page++;
        let query = `?page=${this.page}&limit=${this.limit}`;
        if (this.hilightedTag) {
          query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
        }
        let response = await postAPICall('POST', this.url + query, this.payload);
        if (response.data.length) {
          this.hasMore = response.hasMore;
          this.allForums = [...this.allForums, ...response.data];
          await this.fetchUsersInfo(response.data);
        }
        this.showMoreLoading = false;
      },
      async openTag(tag) {
        this.forumsLoading = true;
        this.$router.push({
          path: '/forums',
          query: {
            ...this.$route.query,
            tag: encodeURIComponent(tag),
          },
        });
        this.hilightedTag = tag;
        this.page = 1;
        let query = `?page=${this.page}&limit=${this.limit}`;
        if (this.hilightedTag) {
          query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
        }
        this.allForums = [];
        let response = await postAPICall('POST', this.url + query, this.payload);
        if (response.data.length) {
          this.hasMore = response.hasMore;
          this.allForums = [...this.allForums, ...response.data];
          await this.fetchUsersInfo(response.data);
        }
        this.forumsLoading = false;
      },
      async removeTag() {
        this.forumsLoading = true;
        let query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.tag;
        this.$router.push({
          path: '/forums',
          query,
        });
        this.hilightedTag = '';
        this.page = 1;
        let routeQuery = `?page=${this.page}&limit=${this.limit}`;
        this.allForums = [];
        let response = await postAPICall('POST', this.url + routeQuery, this.payload);
        if (response.data.length) {
          this.hasMore = response.hasMore;
          this.allForums = [...this.allForums, ...response.data];
          await this.fetchUsersInfo(response.data);
        }
        this.forumsLoading = false;
      },
      getInitials(forum) {
        let user = this.entityUserInfoData[forum.created_by];
        return (
          user?.first_name?.charAt(0)?.toUpperCase() + user?.last_name?.charAt(0)?.toUpperCase()
        );
      },
      getCreatedBy(forum) {
        if (forum.created_by == this.getAuthenticatedUser._id) {
          return 'You';
        }
        let user = this.entityUserInfoData[forum.created_by];
        return user?.first_name + ' ' + user?.last_name;
      },
      isNewForum(forum) {
        if (
          this.getAuthenticatedUser._id != forum.created_by &&
          !forum.read_by.includes(this.getAuthenticatedUser._id)
        ) {
          return true;
        }
        return false;
      },
      async like(index) {
        const response = await postAPICall(
          'POST',
          '/forums/like-thread/' + this.allForums[index]._id
        );
        if (response.success) {
          this.allForums[index].liked_by.push(this.getAuthenticatedUser._id);
        } else {
          this.$message.error('Something went wrong !');
        }
      },
      async dislike(index) {
        const response = await postAPICall(
          'POST',
          '/forums/dislike-thread/' + this.allForums[index]._id
        );
        if (response.success) {
          this.allForums[index].liked_by.splice(
            this.allForums[index].liked_by.indexOf(this.getAuthenticatedUser._id),
            1
          );
        } else {
          this.$message.error('Something went wrong !');
        }
      },
      extractTextFromHTML(htmlString) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || '';
      },
      getUnreadCount(forum) {
        return (
          forum?.comments.filter(
            (c) =>
              c.created_by != this.getAuthenticatedUser._id &&
              !c?.read_by?.includes(this.getAuthenticatedUser._id)
          )?.length || 0
        );
      },
      goBack() {
        this.$router.go(-1);
      },
    },
    watch: {
      async '$route.query.menu_id'() {
        console.log('entered');
        await this.getNecessaryInfo();
      },
    },
  };
</script>
<style lang="scss">
  .truncate-2-lines {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .animated-new-tag {
    animation: pulseTag 1.5s infinite ease-in-out;
  }

  @keyframes pulseTag {
    0%,
    100% {
      transform: scale(0.9);
    }

    50% {
      transform: scale(1);
    }
  }

  .initial {
    grid-template-columns: 35px auto;
    margin-top: 3px;
    margin-bottom: 3px;

    .icon {
      border: 1px solid var(--brand-500);
      text-align: center;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      padding: 5px;
      background-color: transparent;
      box-sizing: border-box;

      .initial-text {
        font-size: 0.8em;
        font-weight: 470;

        span {
          color: var(--brand-500);
        }
      }
    }
  }

  .container {
    width: 330px;
    margin: 0 auto;
  }

  .ask-button-row {
    justify-content: center;
    margin-bottom: 16px;
  }

  .tag-box {
    border: 1px solid var(--page-border);
    border-radius: 16px;
    background-color: var(--card-color);

    .tag-header {
      font-weight: 400;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: clamp(14px, 0.93vw, 18px);
      color: var(--black-950);
      border-bottom: 1px solid var(--page-border);
      padding: 8px;
    }

    .tag-list {
      padding: 12px;

      .tag-row {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 0.75rem;

        .tag-title {
          font-size: clamp(12px, 0.72vw, 14px);
          font-weight: 400;
        }

        &:nth-of-type(odd) {
          .tag-title {
            background-color: #f1e8f924;
            color: #9046cf;
          }
        }

        &:nth-of-type(even) {
          .tag-title {
            background-color: #2196531f;
            color: #219653;
          }
        }
      }
    }
  }

  .gradient-border {
    background: linear-gradient(to right, #b046fe, #e20181);
  }
</style>
